export enum AuthFormEnum {
    shouldBeElevenLength = 'شماره موبایل باید ۱۱ رقم باشد.',
    globalError  = "خطایی رخ داد. لطفا دوباره تلاش کنید.",
    register = 'ثبت نام',
    login = 'ورود' ,
}

//unused but saw inside a file : ExceptionProvider.js
export enum AuthMessageEnum {
    notFound = "پیدا نشد",
    notAllowed = "اجازه دسترسی ندارید",
    tooManyRequests = "تعداد ریکوئست های بالا",
    serverError = "خطای سرور"
}